module.exports = __webpack_public_path__ + "img/apple-logo.dc899210.svg";